import logo from './logo.svg';
import './App.css';
import Layout from './components/common/layout/layout'
import { useEffect } from 'react';
import AOS from 'aos';
import $ from 'jquery';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
function App() {
 useEffect(() => {
    AOS.init({ duration: 800, easing: 'slide' });

    // Full height
    
    // Navbar scroll
    const handleScroll = () => {
      const st = window.scrollY;
      const navbar = $('.ftco_navbar');
      const sd = $('.js-scroll-wrap');

      if (st > 150) navbar.addClass('scrolled');
      else navbar.removeClass('scrolled sleep');

      if (st > 350) {
        navbar.addClass('awake');
        sd.addClass('sleep');
      } else {
        navbar.removeClass('awake').addClass('sleep');
        sd.removeClass('sleep');
      }
    };
    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {

      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
     <Layout />
  );
}

export default App;
